import React from 'react';
import T from 'i18n-react';

const HistoryButton = ({onClick, onClickBack, disabled=false}) => (
    <div className="row btn-block-history btm-cnt-hist">
        <div className="col-md-6">
        <button type="button"  className="curr-pointer btn-history-back btn btn-warning"
                        onClick={()=> {onClickBack()}}>
                      <T.text tag='span' text="back"/>
        </button>
        </div>
        <div className="col-md-6">
        <button type="button"  className="curr-pointer btn-history btn btn-warning"
                onClick={() => {onClick()}} disabled={disabled} >
                <T.text tag='span' text="export_history"/>
        </button>
        </div>
</div>
);

export default  HistoryButton;



// WEBPACK FOOTER //
// ./src/components/history/HistoryButton.js